export const QUERY_PARAM_KEY = {
  taxFilingTab: 'taxFilingTab',
  confirmInfoTab: 'confirmInfoTab',
  uploadDocumentsTab: 'uploadDocumentsTab',
  prevTaxReturnsTab: 'prevTaxReturnsTab',
};

export const QUERY_PARAM_VALUE = {
  uploadDocuments: 'uploadDocuments',
  confirmInfo: 'confirmInfo',
  checkingStages: 'checkingStages',
  personal: 'personal',
  business: 'business',
  dependents: 'dependents',
  filingInfo: 'filingInfo',
};
